import './lib/tenant/tenant-session-boot';
import './lib/offline/pwa-install';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import { bootTenantColors } from './lib/theme/tenant-colors';
import { bootTenantHead } from './lib/theme/tenant-head';
import { bootTenantFont } from './lib/theme/tenant-font';
import { startQueryPersistence } from './lib/offline/query-persist';
import { showHierarchyNamesInToasts } from './lib/hierarchy-toast';
import { registerServiceWorker } from './lib/offline/register-sw';
import { syncManager } from './lib/offline/sync-manager';
import './styles/index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
});

bootTenantColors();
bootTenantHead();
bootTenantFont();
showHierarchyNamesInToasts();

startQueryPersistence();
registerServiceWorker();
syncManager.start();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element with id "root" not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
